export enum ENote {
  C = 'C',
  D = 'D',
  E = 'E',
  F = 'F',
  G = 'G',
  A = 'A',
  B = 'B'
}

export const notes = [
  ENote.C,
  ENote.D,
  ENote.E,
  ENote.F,
  ENote.G,
  ENote.A,
  ENote.B
]

export interface INoteSounds {
  [key: string]: Object
}
